import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { DropdownButtonWithChip } from "./DropdownButtons.js";
const useClasses = makeStyles()((theme) => ({
  selectButton: {
    height: theme.custom.denseButtonHeight
  },
  selectButtonMobileFullWidth: {
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  }
}));
const DropdownWithChip = ({
  label,
  selectedText,
  styles,
  closeOnClickInside,
  children,
  isMobileFullWidth = true,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const { classes } = useClasses();
  const handleDropdownOpen = () => {
    setOpen(true);
  };
  const handleDropdownClose = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButtonWithChip,
    {
      ...props,
      label,
      selectedText,
      open,
      onDropdownOpen: handleDropdownOpen,
      onDropdownClose: handleDropdownClose,
      closeOnClickInside: closeOnClickInside ?? false,
      styles: {
        dropdownButton: `${classes.selectButton} ${isMobileFullWidth ? classes.selectButtonMobileFullWidth : ""} ${styles?.dropdownButton}`,
        ...styles
      }
    },
    children
  );
};
export {
  DropdownWithChip
};
//# sourceMappingURL=DropdownWithChip.js.map
